import PropTypes from 'prop-types';
import React from 'react';

export const BigArrow = ({ className }) => {
  return (
    <svg className={className} width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.5 1L8 7.5L14.5 1" stroke="currentColor" strokeWidth="1.6" />
    </svg>
  );
};

BigArrow.propTypes = {
  className: PropTypes.string,
};
